import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @classdesc
 * Defines the parts of an observation that are not time specific.
 *
 * @memberof system-metadata
 * @property {number} id
 * @property {string} systemName
 * @property {string} friendlyShortName
 * @property {string} friendlyLongName
 * @property {system-metadata.ApportionmentType} apportionmentType
 * @property {boolean} isDefaultNormalizer
 * @property {boolean} isExistsForNormalization
 * @property {string} normalizationName
 * @property {system-metadata.Attribution} attribution
 * @property {system-metadata.Description} description
 * @property {system-metadata.StatisticalType} statisticalType
 * @property {string} unit
 * @property {string} numericFormat
 * @property {system-metadata.CharacteristicType} universeType
 * @property {object} dataSource
 * @property {object} crosstabContext
 * @property {date} loadedAt
 */
class CharacteristicType extends ActiveRecord {
}
CharacteristicType.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default CharacteristicType;
